import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RoomsService {

  categories: any = [
    {
      id: 1,
      title: 'Salas Abiertas'
    },
    {
      id: 2,
      title: 'Salas Cerradas'
    },
    {
      id: 3,
      title: 'Auditorios'
    },
    {
      id: 4,
      title: 'Espacios Abiertos'
    },
    {
      id: 5,
      title: 'Pisos'
    },
  ];

  sucursales: any = [
    {
      id: 1,
      title: 'Chacaito',
      urlImg: 'assets/images/WeChacaito/fachada.jpg',
      address: 'Torre Delta, Av. El Parque con Av. Santa Lucía Urb. El Bosque, Sector Chacaíto, Chacao, Caracas-Venezuela',
      coords: {lat: 10.492196, lng: -66.866565},
      placeId: 'ChIJJ8aBeSxZKowR7y6nu1zwprA'
    },
    {
      id: 2,
      title: 'C.C.C.T',
      urlImg: 'assets/images/WeCCCT/fachada.png',
      address: 'Centro Comercial Ciudad Tamanaco, Pirámide Invertida, Oficina 134, Autopista Francisco Fajardo, Caracas-Venezuela',
      coords: {lat: 10.485579500972522, lng: -66.85542575551302},
      placeId: 'ChIJR2LnUFNZKowRa3jqJbZeJts'
    },
    {
      id: 3,
      title: 'Chacao',
      urlImg: 'assets/images/WeChacao/fachada.jpeg',
      address: 'Chacao, Edificio El Carmen, Av. San Ignacio de Loyola, Caracas-Venezuela',
      coords: {lat: 10.490124358112865, lng: -66.86629275510855},
      placeId: 'ChIJm624A75ZKowRlvjRBV0qshM'
    },
    {
      id: 4,
      title: 'Suite C.C.T',
      urlImg: 'assets/images/WeLiving/fachada.webp',
      address: 'Centro Comercial Ciudad Tamanaco, Pirámide Invertida, Oficina 134, Autopista Francisco Fajardo, Caracas-Venezuela',
      coords: {lat: 10.4846968, lng: -66.8546229},
      placeId: 'ChIJxd5849JZKowRR5ttVivhITw'
    },
  ];

  rooms: any = [
    {
      id: 1,
      categoryId: this.getCategory(1).id,
      sucursalId: this.getSucursal(1).id,
      title: 'El Kiosko',
      cobotUrl: 'https://external-bookings.apps.cobot.me/2b1a09cf-1aec-4849-86a4-8c505c84572b/book',
      activeRoom: 1,
      images: [
        {
          id: 1,
          urlName: 'assets/images/WeChacaito/kiosko.jpeg'
        }
      ]
    },
    {
      id: 2,
      categoryId: this.getCategory(1).id,
      sucursalId: this.getSucursal(1).id,
      title: 'El Telar',
      cobotUrl: 'https://external-bookings.apps.cobot.me/4216dc94-efd0-41ae-baa1-082c4ddab8b9/book',
      activeRoom: 1,
      images: [
        {
          id: 1,
          urlName: 'assets/images/WeChacaito/ElTelarpiso1.jpg'
        }
      ]
    },
    {
      id: 3,
      categoryId: this.getCategory(1).id,
      sucursalId: this.getSucursal(1).id,
      title: 'El Poste',
      cobotUrl: 'https://external-bookings.apps.cobot.me/721ca981-63b5-411f-82ff-ee4719a7d076/book',
      activeRoom: 1,
      images: [
        {
          id: 1,
          urlName: 'assets/images/WeChacaito/ElPostePiso1.jpg'
        }
      ]
    },
    {
      id: 4,
      categoryId: this.getCategory(2).id,
      sucursalId: this.getSucursal(1).id,
      title: 'La del Medio',
      cobotUrl: 'https://external-bookings.apps.cobot.me/acd8a887-291d-4486-8ed9-4cf13aecc3fb/book',
      activeRoom: 1,
      images: [
        {
          id: 1,
          urlName: 'assets/images/WeChacaito/LadelMedioPiso1.JPG'
        }
      ]
    },
    {
      id: 5,
      categoryId: this.getCategory(2).id,
      sucursalId: this.getSucursal(1).id,
      title: 'La Esquina',
      cobotUrl: 'https://external-bookings.apps.cobot.me/35305d12-6db5-4f0d-811b-ca2ef80e5d05/book',
      activeRoom: 1,
      images: [
        {
          id: 1,
          urlName: 'assets/images/WeChacaito/laEsquina.jpeg'
        }
      ]
    },
    {
      id: 6,
      categoryId: this.getCategory(3).id,
      sucursalId: this.getSucursal(1).id,
      title: 'La Bodega',
      cobotUrl: 'https://external-bookings.apps.cobot.me/246662c8-5466-401a-980a-382189dc5e54/book',
      activeRoom: 1,
      images: [
        {
          id: 1,
          urlName: 'assets/images/WeChacaito/Labodega.jpg'
        }
      ]
    },
    {
      id: 7,
      categoryId: this.getCategory(3).id,
      sucursalId: this.getSucursal(1).id,
      title: 'La Farmacia',
      cobotUrl: 'https://external-bookings.apps.cobot.me/f2c093af-e6d1-4a90-90c9-c6e8c6056113/book',
      activeRoom: 1,
      images: [
        {
          id: 1,
          urlName: 'assets/images/WeChacaito/LaFarmacia.jpg'
        }
      ]
    },
    {
      id: 8,
      categoryId: this.getCategory(3).id,
      sucursalId: this.getSucursal(1).id,
      title: 'La Boveda',
      cobotUrl: 'https://external-bookings.apps.cobot.me/8b028890-c402-474f-855d-c4beffaf0ce4/book',
      activeRoom: 1,
      images: [
        {
          id: 1,
          urlName: 'assets/images/WeChacaito/Laboveda.jpg'
        }
      ]
    },
    {
      id: 9,
      categoryId: this.getCategory(4).id,
      sucursalId: this.getSucursal(1).id,
      title: 'La Terraza',
      cobotUrl: 'https://external-bookings.apps.cobot.me/99a549b6-f3af-4218-b4d8-b3d2b3761fff/book',
      activeRoom: 1,
      images: [
        {
          id: 1,
          urlName: 'assets/images/WeChacaito/Laterrazapiso5.jpg'
        }
      ]
    },
    {
      id: 9,
      categoryId: this.getCategory(5).id,
      sucursalId: this.getSucursal(1).id,
      title: 'Pisos',
      cobotUrl: '#',
      activeRoom: 0,
      images: [
        {
          id: 1,
          urlName: 'assets/images/WeChacaito/Piso1Salas.JPG'
        }
      ]
    },
    {
      id: 10,
      categoryId: this.getCategory(2).id,
      sucursalId: this.getSucursal(2).id,
      title: 'Torre A',
      cobotUrl: '#',
      activeRoom: 1,
      images: [
        {
          id: 1,
          urlName: 'assets/images/WeCCCT/OficinasemiprivadaLaMedianaTorreA.jpeg'
        }
      ]
    },
    {
      id: 11,
      categoryId: this.getCategory(2).id,
      sucursalId: this.getSucursal(2).id,
      title: 'El Hexaedro',
      cobotUrl: 'https://external-bookings.apps.cobot.me/3bbc4dab-7e1a-420a-bfb8-fd649baacc77/book',
      activeRoom: 1,
      images: [
        {
          id: 1,
          urlName: 'assets/images/WeCCCT/CCCTsalaHexahedro.JPG'
        }
      ]
    },
    {
      id: 12,
      categoryId: this.getCategory(2).id,
      sucursalId: this.getSucursal(2).id,
      title: 'Torre D',
      cobotUrl: '#',
      activeRoom: 1,
      images: [
        {
          id: 1,
          urlName: 'assets/images/WeCCCT/torreDEmpresarial.jpeg'
        }
      ]
    },
    {
      id: 13,
      categoryId: this.getCategory(5).id,
      sucursalId: this.getSucursal(3).id,
      title: 'Pisos',
      cobotUrl: '#',
      activeRoom: 1,
      images: [
        {
          id: 1,
          urlName: 'assets/images/WeChacao/intima.jpeg'
        }
      ]
    },
    {
      id: 14,
      categoryId: this.getCategory(5).id,
      sucursalId: this.getSucursal(4).id,
      title: 'Vista al Avila',
      cobotUrl: 'https://airbnb.com/h/wecodesuiteavila',
      activeRoom: 1,
      images: [
        {
          id: 1,
          urlName: 'assets/images/WeLiving/intima1.jpg'
        }
      ]
    },
    {
      id: 15,
      categoryId: this.getCategory(5).id,
      sucursalId: this.getSucursal(4).id,
      title: 'Vista a Caracas',
      cobotUrl: 'https://airbnb.com/h/wecodesuite',
      activeRoom: 1,
      images: [
        {
          id: 1,
          urlName: 'assets/images/WeLiving/intima2.webp'
        }
      ]
    },
  ];


  constructor() { }

  getCategory(categoryId: number){
    const category = this.categories.filter((category) => category.id === categoryId)[0];
    return category;
  }

  getSucursal(sucursalId: number){
    const sucursal = this.sucursales.filter((sucursal) => sucursal.id === sucursalId)[0];
    return sucursal;
  }

  getSucursales(){
    return this.sucursales;
  }


  getRooms(){
    return this.rooms;
  }
}
